"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrimaryRemoteHOCFactory = exports.EmotionProviderHOCFactory = void 0;
var helpers_1 = require("../../../helpers");
var main_1 = require("../../../main");
var EditMode_style_1 = require("../../../styles/EditMode.style");
var common_mfe_1 = require("../../common-mfe");
var mfeSettings_1 = require("../../mfeSettings");
function EmotionProviderHOCFactory(React, _a, createCache) {
    var _b = _a === void 0 ? {} : _a, _c = _b.CacheProvider, CacheProvider = _c === void 0 ? null : _c;
    if (createCache === void 0) { createCache = null; }
    return function (AppComponent) {
        return function (props) {
            var children = React.createElement(AppComponent, props);
            return CacheProvider && createCache
                ? React.createElement(CacheProvider, {
                    value: createCache({
                        key: (props.__mfeName__ ||
                            props.name ||
                            "emotion").toLowerCase(),
                    }),
                }, children)
                : children;
        };
    };
}
exports.EmotionProviderHOCFactory = EmotionProviderHOCFactory;
function PrimaryRemoteHOCFactory(React, styled, EmotionReact, createCache) {
    var _this = this;
    if (EmotionReact === void 0) { EmotionReact = {}; }
    if (createCache === void 0) { createCache = null; }
    var EmotionProviderHOC = EmotionProviderHOCFactory(React, EmotionReact, createCache);
    return function (App) {
        return EmotionProviderHOC(function (props) {
            var _a = props.touchpoint, touchpoint = _a === void 0 ? common_mfe_1.TOUCHPOINTS.UNIPOLSAI : _a, colorClassDesktop = props.colorClassDesktop, __host__ = props.__host__, __mfeName__ = props.__mfeName__;
            var primaryVisibilityConfig = props.config && props.config["VisualizzaWidget"];
            var _b = React.useState(!primaryVisibilityConfig ||
                main_1.Helpers.RemoteHelper.getSelectedValue(primaryVisibilityConfig.value) === "Si"), isVisible = _b[0], setIsVisible = _b[1];
            var VisibilityMask = function (visibilityMaskProps) {
                return (visibilityMaskProps.isEditMode &&
                    primaryVisibilityConfig &&
                    main_1.Helpers.RemoteHelper.getSelectedValue(primaryVisibilityConfig.value) == "No" &&
                    React.createElement(styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n              ", "\n            "], ["\n              ", "\n            "])), EditMode_style_1.visibilityMaskStyle), {
                        className: "primary-disabled-mask",
                    }));
            };
            var EditModeIconsContainer = function (editModeIconsContainerProps) {
                return (editModeIconsContainerProps.isEditMode &&
                    editModeIconsContainerProps.__mfeName__ !== mfeSettings_1.MFE_NAMES.tpdHeader &&
                    editModeIconsContainerProps.__mfeName__ !== mfeSettings_1.MFE_NAMES.tpdFooter &&
                    React.createElement(styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n              ", "\n            "], ["\n              ", "\n            "])), EditMode_style_1.EditModeIconsContainerStyle), {
                        className: "icons-container",
                    }, SettingsIcon(editModeIconsContainerProps), VisibilityIcon(editModeIconsContainerProps)));
            };
            var SettingsIcon = function (settingsIconProps) {
                var IconSetting = styled.img(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n          content: url(\"/NextAssets/icons/settings.svg\");\n          ", "\n        "], ["\n          content: url(\"/NextAssets/icons/settings.svg\");\n          ", "\n        "])), EditMode_style_1.PrimarySettingsIcon);
                return React.createElement(IconSetting, {
                    onClick: function () {
                        var _a, _b;
                        helpers_1.EditContentHelper.triggerEditContent((_b = (_a = settingsIconProps.__host__) === null || _a === void 0 ? void 0 : _a.placement) === null || _b === void 0 ? void 0 : _b.actionContent, helpers_1.EditMode.read);
                    },
                    className: "icon-settings",
                });
            };
            var VisibilityIcon = function (visibilityProps) {
                if (primaryVisibilityConfig) {
                    var imgFile = main_1.Helpers.RemoteHelper.getSelectedValue(primaryVisibilityConfig.value) == "Si"
                        ? "view"
                        : "hidden";
                    var IconVisibility = styled.img(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n            content: url(\"/NextAssets/icons/", ".svg\");\n            ", "\n          "], ["\n            content: url(\"/NextAssets/icons/", ".svg\");\n            ", "\n          "])), imgFile, EditMode_style_1.PrimaryVisibilityIcon);
                    var host_1 = visibilityProps.__host__;
                    return React.createElement(IconVisibility, {
                        onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                            var precVisibilityValue, newValue;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        precVisibilityValue = isVisible;
                                        newValue = __assign(__assign({}, primaryVisibilityConfig), { value: primaryVisibilityConfig.value.map(function (option) {
                                                option.selected =
                                                    option.selected === "true" ? "false" : "true";
                                                return option;
                                            }) });
                                        return [4 /*yield*/, main_1.Providers.CMSProxyService.getInstance()
                                                .saveContent(host_1.placement.dataContentId, host_1.placement.projectId, host_1.placement.projectName, [newValue], host_1.placement.keywords, host_1.placement.contentName)
                                                .then(setIsVisible(!isVisible))
                                                .catch(function (error) {
                                                main_1.Helpers.ConsoleHelper.error(error);
                                                alert("Errore: Non è stato possibile salvare il contenuto");
                                                setIsVisible(precVisibilityValue);
                                            })];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); },
                        className: "icon-visibility",
                    });
                }
            };
            return React.createElement(styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n          position: relative;\n        "], ["\n          position: relative;\n        "]))), {
                style: {
                    position: "relative",
                    minHeight: props.isEditMode ? "100px" : "",
                },
                className: "".concat((0, common_mfe_1.getTouchpointThemeClass)(touchpoint), " ").concat((0, common_mfe_1.getPageColorThemeClass)(colorClassDesktop ||
                    (__host__.pageProperties &&
                        __host__.pageProperties.colorClassDesktop)), " ").concat((props.isEditMode && "is-edit-mode-active") || ""),
            }, VisibilityMask(props), EditModeIconsContainer(props), App(props));
        });
    };
}
exports.PrimaryRemoteHOCFactory = PrimaryRemoteHOCFactory;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
